import React, { useEffect, useState } from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const getRandomData = () => new Array(7).fill(0).map(() => Math.floor(Math.random() * 100));

const getState = (dataIndicador) => {
  let resumeIndicator = {
    labels: getFilterNamesData(dataIndicador),
    datasets: [
      {
        label: 'Resumen',
        backgroundColor: '#55e5bb',
        borderColor: '#55e5bb',
        borderWidth: 1,
        hoverBackgroundColor: '#55e5bb',
        hoverBorderColor: '#55e5bb',
        data: getWaitingDays(dataIndicador),
      },
    ],
  }
  return resumeIndicator;
};

const options = {
  legend: {
    position: 'bottom',
  },
  indexAxis: 'y',
  scales: {
    x: {
      ticks: {
        maxRotation: 0,
        minRotation: 0
      }
    },
    y: {
      ticks: {
        maxRotation: 0,
        minRotation: 0
      }
    }
  }
};

const getFilterNamesData = (dataIndicator) => {
  let arrNombres = [];
  for (let i = 0; i < dataIndicator.length; i++) {
    arrNombres.push(dataIndicator[i].nombre_servicio);
    if (i == 12) {
      break;
    }
  }
  return arrNombres;
}

const getWaitingDays = (dataIndicator) => {
  let arrDays = [];
  for (let i = 0; i < dataIndicator.length; i++) {
    arrDays.push(dataIndicator[i].sumatoriaDiasFechaSolicitada);
    if (i == 12) {
      break;
    }
  }
  return arrDays;
}

const AnimatedBars = ({ dataIndicator }) => {

  const [data, setData] = useState(null);

  useEffect(() => {
    getDataIndicator(dataIndicator);
  }, []);

  const getDataIndicator = async (dataIndicator) => {
    let dataInd = await getState(dataIndicator);
    setData(dataInd);
  }

  return (
    <Col>
      <Card>
        <CardBody>
          <div className="card__title">
            {/*<h5 className="bold-text">{t('charts.react_chartjs.random_animated_bars')}</h5>*/}
          </div>
          {data != null ? <Bar height={70} data={data} options={options} /> : null}
        </CardBody>
      </Card>
    </Col>
  );
};

export default AnimatedBars;
